import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { I18nPipe } from '@bbitgmbh/website.sdk';
import { HierarchicalMenuService } from './hierarchical-menu.service';

@Component({
  selector: 'app-hierarchical-menu',
  templateUrl: './hierarchical-menu.component.html',
  styleUrls: ['./hierarchical-menu.component.scss'],
  imports: [NgTemplateOutlet, NgClass, AsyncPipe, I18nPipe],
})
export class HierarchicalMenuComponent {
  service = inject(HierarchicalMenuService);

  readonly showCount = input(false);
}
